<script setup lang="ts">
import type { FieldSchema } from '../../../types';

defineOptions({ inheritAttrs: false });

defineProps<{
  field?: FieldSchema;
  label?: string;
}>();
</script>

<template>
  <h1 :class="['w-full border-b text-lg font-semibold text-gray-600', field?.settings?.small ? '' : 'mb-3 lg:text-xl']">
    {{ field?.label || label }}
  </h1>
</template>
